// communication methods between hosting web page and extension content script

import { AppState, FlowGraph } from "../types/AppState";

export type RunAppCommand = {
  type: 'runApp';
  flowId?: string,
  clientId?: string;
  appStateWithGraph?: AppState & { graph: FlowGraph };
  runInBackground?: boolean;
}


export type HandshakeCommand = {
  type: 'handshake';
}

export type ExtensionCommand = RunAppCommand | HandshakeCommand;


export type HandshakeAck = {
  type: 'handshakeAck';
}

export function isRunAppCommand(command: ExtensionCommand | HandshakeAck): command is RunAppCommand {
  return command.type === 'runApp';
}

export function isHandshakeCommand(command: ExtensionCommand | HandshakeAck): command is HandshakeCommand {
  return command.type === 'handshake';
}

export function sendCommandToExtension(command: ExtensionCommand) {
  window.postMessage(command);
}
